<template>
  <section class="project-roles-tab">
    <div class="roles-list">
      <table-component :class-name="'roles-list-table'"
                       :column-width="columnWidth"
                       :legend="createLegend()"
                       :columns="columns"
                       :all-checked="allChecked"
                       :clearChecked="clearChecked"
                       @changeCheckbox="checkedRoles = $event"
                       @filterName="filterName"
                       @filterProject="filterProject"
                       @filterPermissions="filterPermissions"
                       @filterOwner="filterOwner"
                       @checkAll="checkAll"
        ></table-component>
    </div>
  </section>
</template>

<script>
  import {tableComponentMixin} from "../../../../mixins/utils/tableComponentMixin";
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import {singleProject} from "../../../../mixins/projects/singleProject";

  export default {
    name: "projectRoles",
    mixins: [tableComponentMixin, singleProject],
    data() {
      return {
        nameUp: true,
        nameDown: true,
        nameActive: false,

        projectsUp: true,
        projectsDown: true,
        projectsActive: false,

        ownerUp: true,
        ownerDown: true,
        ownerActive: false,

        permissionUp: true,
        permissionDown: true,
        permissionActive: false,
        legend: [],

        columnWidth: [285/1140 * 100, 285/1140 * 100, 285/1140 * 100, 285/1140 * 100, 0],
        clearChecked: false,

      }
    },
    computed: {
      ...mapState({
        rolesData: state => state.roles.ownedRoles,
        projects: state => state.projects.allProjects,
        checkedRolesData: state => state.projects.checkedRoles
      }),
      ...mapGetters({
        projectOwner: 'projects/projectOwnerRole',
        singleItems: 'roles/interfaceSingleItems',
      }),
      checkedRoles: {
        get() {
          return this.checkedRolesData
        },
        set(val) {
          this.setCheckedRoles(val)
        }
      },
      allChecked() {
        return this.checkedRoles.length == this.itemsInProject.length && this.checkedRoles.length > 0
      },

      itemsInProject() {
        let projectId = this.$route.params.id;
        if (this.$route.name.includes('projectItem')) {
          projectId = this.$route.params.item
        };
        let activeProject = this.project;
        let arr = [];


        if (activeProject) {
          let permissions = activeProject.permissions;

          arr = this.singleItems.filter(item => {
            for (let permission of permissions) {
              if (item.id == permission.role_id) {
                item.permission = permission;
                return true
              }
            }
          });

        }
        return arr;
      },
      rolesTable() {
        let arr = this.itemsInProject.slice();

        if (this.nameActive) {
          arr.sort((a,b) => {
            let nameA = a.name;
            let nameB = b.name;

            if (this.nameDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.nameUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        };

        if (this.projectsActive) {
          arr.sort((a,b) => {
            let nameA = a.tags.length;
            let nameB = b.tags.length;

            if (this.projectsDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.projectsUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        };

        if (this.permissionActive) {
          arr.sort((a,b) => {
            let nameA = a.permission.value
            let nameB = b.permission.value

            if (this.permissionDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.permissionUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        };

        if (this.ownerActive) {
          arr.sort((a,b) => {
            let nameA = a.users.length
            let nameB = b.users.length

            if (this.ownerDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.ownerUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        }

        return arr;
      },
      columns() {

        //cетим в стор дисплейед ролес
        this.setDisplayedRolesInCellProjectRoles(this.rolesTable)

        let rolesArr = this.rolesTable.filter(item => item.deleted_at === null)

        return rolesArr.map(item => {
          return {
            dblClick: item.id,
            dblClickPrefix: '/roles/role/',
            cells: [
              {
                text: {
                  text: item.name,
                  isLink: false,
                  isTrimmed: true,
                  // trimWidth: 30
                  trimWidth: 1
                },
                avatar: {
                  isAvatar: false
                }
              },
              {
                text: {
                  text: '',

                },
                avatar: {
                  isAvatar: false,
                },
                tagsArray: item.tags
              },
              {
                text: {
                  text: this.returnPermission(item.permission.value),
                  isLink: false,
                },
                avatar: {
                  isAvatar: false,
                }
              },
              {
                text: {
                  text: '',
                },
                avatar: {
                  isAvatar: false,
                  // avatarLink: item.image_url
                },
                usersArray: this.returnUsersData(item)
              },
              {
                text: {
                  isLink: true,
                  text: '',
                  linkPrefix: '/roles/role/',
                  link: item.id
                },
                avatar: {
                  isAvatar: false
                },
                isGear: true
              }
            ],
            item
          }
        })
      },
    },
    watch: {
      checkedRolesData(val) {
        if (val.length === 0) {
          this.clearChecked = true;
          setTimeout(() => this.clearChecked = false, 100);
        }
      }
    },
    methods: {
      ...mapMutations({
        setCheckedRoles: 'projects/SET_CHECKED_ROLES', //тут сетим роли в проекты?
        setDisplayedRolesInCellProjectRoles: 'projects/SET_DISPLAYED_ROLES_IN_CELL_PROJECT_ROLES'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('popups.addRole.nameLb'),
            filterMethod: 'filterName',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('roles.tags'),
            filterMethod: 'filterProject',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('roles.permissions'),
            filterMethod: 'filterPermissions',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('roles.roleUsersTite'),
            filterMethod: 'filterOwner',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: '',
            legendSort: false,
            isGear: true
          }
        ]
      },
      returnPermission(val) {
        switch (val) {
          case(1): return this.$t('things.per1');
            break;
          case(2): return `${this.$t('things.per1')}, ${this.$t('things.per2')}`
            break;
          case(3): return `${this.$t('things.per1')}, ${this.$t('things.per2')}, ${this.$t('things.per3')}`
            break;
          case(4): return `Владелец`
        }
      },
      returnUsersData(item) {
        return item.users.map(item => {
          return {
            avatar: item.contacts.avatar_url,
            first_name: item.first_name,
            second_name: item.second_name
          }
        })
      },
      checkAll() {
        if (this.allChecked) {
          this.checkedRoles = [];
        } else {
          this.checkedRoles = this.itemsInProject
        }
      },
      filterName(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = true;
        this.projectsActive = false;
        this.permissionActive = false;
        this.ownerActive = false;

        this.projectsUp = true;
        this.projectsDown = true;
        this.permissionUp = true;
        this.permissionDown = true;
        this.ownerUp = true;
        this.ownerDown = true;

        if (this.nameUp && this.nameDown) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.nameUp) {
          this.nameUp = false;
          this.nameDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.nameDown) {
          this.nameUp = true;
          this.nameDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
      filterProject(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = false;
        this.projectsActive = true;
        this.permissionActive = false;
        this.ownerActive = false;

        this.nameUp = true;
        this.nameDown = true;
        this.permissionUp = true;
        this.permissionDown = true;
        this.ownerUp = true;
        this.ownerDown = true;

        if (this.projectsUp && this.projectsDown) {
          this.projectsDown = true;
          this.projectsUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.projectsUp) {
          this.projectsUp = false;
          this.projectsDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.projectsDown) {
          this.projectsUp = true;
          this.projectsDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
      filterPermissions(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = false;
        this.projectsActive = false;
        this.permissionActive = true;
        this.ownerActive = false;

        this.nameUp = true;
        this.nameDown = true;
        this.projectsUp = true;
        this.projectsDown = true;
        this.ownerUp = true;
        this.ownerDown = true;

        if (this.permissionUp && this.permissionDown) {
          this.permissionDown = true;
          this.permissionUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.permissionUp) {
          this.permissionUp = false;
          this.permissionDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.projectsDown) {
          this.permissionUp = true;
          this.permissionDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
      filterOwner(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = false;
        this.projectsActive = false;
        this.permissionActive = false;
        this.ownerActive = true;

        this.nameUp = true;
        this.nameDown = true;
        this.projectsUp = true;
        this.projectsDown = true;
        this.permissionUp = true;
        this.permissionDown = true;

        if (this.ownerUp && this.ownerDown) {
          this.ownerDown = true;
          this.ownerUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.ownerUp) {
          this.ownerUp = false;
          this.ownerDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.ownerDown) {
          this.ownerUp = true;
          this.ownerDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
      ownerRole(id) {
        return this.projectOwner(id)
      },
    },
    destroyed() {
      this.checkedRoles = [];
    }

  }
</script>

<style lang="scss" scoped>

.roles-list-table {
  padding: 20px 0 0;
}
</style>
